import Vue from 'vue';
import vuex from 'vuex';

Vue.use(vuex);

/* const store = new vuex.Store({
  state: {
    show: false,
    themecolor: '20a0ff' // 默认为20a0ff
  },
  mutations: {
    // 更新主题颜色
    setThemeColor(state, curcolor) {
      this.state.themecolor = curcolor;
    }
  }
}); */

/**
 *  vuex全局状态管理
 *  @param options左侧栏路由目录
 *
 *  初始化时用sessionStore.getItem('token'),这样子刷新页面就无需重新登录
 *  state 访问状态对象，spa中所说的共享值
 *  vuex 提供了commit的方法修改state的状态
* */

export default new vuex.Store({
  state: {
    show: false,
    carGoodsList: sessionStorage['carGoodsList'] ? JSON.parse(sessionStorage['carGoodsList']) : [], // 购物车
    token: '',
    tabs: sessionStorage['tabs'] ? JSON.parse(sessionStorage['tabs']) : [], // tabs数据
    tabsPosition: sessionStorage['tabsPosition'] ? sessionStorage['tabsPosition'] : '/home/index', // tabs定位
    refundCountInfo: sessionStorage['refundCountInfo'] ? JSON.parse(sessionStorage['refundCountInfo']) : [] // 售后单类型统计
   /* Header: {
      headers: {
        // 'Accept': 'application/json',
        'Authorization': 'BasicAuth ' + sessionStorage.getItem('token')
      }
    } // 请求头 */
  },
  mutations: {
    // 存token
    setToken: (state, token) => {
      state.token = token;
      sessionStorage.token = token;
    },
    delToken: (state) => {
      state.token = '';
      sessionStorage.removeItem('token');
    },

    // 存tabs
    updateTabs: (state, data) => {
      state.tabs = data;
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs));
    },

    updateTabsPosition: (state, data) => {
      state.tabsPosition = data;
      sessionStorage.setItem('tabsPosition', state.tabsPosition);
    },
    clearTabs: (state) => {
      state.tabs.splice(0, state.tabs.length);
      sessionStorage.setItem('tabs', JSON.stringify(state.tabs));
    },

    // 存购物车
    addCarGoods: (state, data) => {
      // state.carGoodsList.push(data);
      state.carGoodsList = data;
      sessionStorage.setItem('carGoodsList', JSON.stringify(state.carGoodsList));
    },
    deleteCarGoods(state, index) {
      state.carGoodsList.splice(index, 1);
      sessionStorage.setItem('carGoodsList', JSON.stringify(state.carGoodsList));
    },
    updateCarGoods(state, data) {
      const {index, key, value} = data;
      state.carGoodsList[index][key] = value;
      sessionStorage.setItem('carGoodsList', JSON.stringify(state.carGoodsList));
    },
    clearCarGoods(state) {
      state.carGoodsList.splice(0, state.carGoodsList.length);
      sessionStorage.setItem('carGoodsList', JSON.stringify(state.carGoodsList));
    },

    // 存售后单处理数据
    updateAfterOrder(state, data) {
      state.refundCountInfo = data;
      sessionStorage.setItem('refundCountInfo', JSON.stringify(state.refundCountInfo));
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js